﻿<template>
    <masked-input-bs :name="name" :value="value" :required="required" :label-cols ="labelCols" :validation-rules="{ regex: /^\d{5}$/}" :mask="[/\d/, /\d/, /\d/, /\d/, /\d/]" v-on:input="updateValue($event)"></masked-input-bs>    
</template>

<script>
    var maskedInputBs = require('./maskedInputBs.vue');
    module.exports = {
        components: {
            maskedInputBs: maskedInputBs
        },
        props: {
            name: {
                type: String,
                required: true
            },
            value: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            labelCols: {
                type: Number,
                default: 4
            }
        },
        computed: {           
        },
        methods: {
            updateValue: function (value) {                
                var formattedValue = value.trim();
                this.$emit('input', formattedValue);
            }
        }
    }
</script>